import { Sparkles, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative pt-8 pb-14 sm:pt-16 sm:pb-24" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 animate-slide-up">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-soft/60 text-[#7a5a17] text-xs font-medium" data-testid="hero-badge">
            <Sparkles className="w-3.5 h-3.5" />
            The SummaryMaps Journal
          </div>

          <h1 className="mt-5 sm:mt-6 font-serif font-semibold leading-[1.05] text-4xl sm:text-5xl lg:text-7xl text-ink">
            Quiet writing<br />
            about the books<br />
            <span className="italic text-brand">that won't leave you alone.</span>
          </h1>

          <p className="mt-5 sm:mt-7 text-base sm:text-lg text-ink-muted max-w-xl leading-relaxed">
            Mindmaps, study notes, education essays and new-release breakdowns —
            short reads that help you remember what you read, the way SummaryMaps does for whole books.
          </p>

          <div className="mt-7 sm:mt-10 flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 sm:gap-4">
            <a href="#articles" className="inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3.5 rounded-full bg-brand text-white text-base font-medium hover:bg-brand-hover transition-all shadow-md hover:shadow-lg" data-testid="hero-primary-cta">
              Read the latest <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#newsletter" className="inline-flex items-center justify-center gap-2 px-6 sm:px-7 py-3.5 rounded-full bg-white border border-ink/10 text-ink text-base font-medium hover:border-brand/40 hover:text-brand transition-all" data-testid="hero-secondary-cta">
              Get it weekly
            </a>
          </div>

          <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-x-4 gap-y-2 text-[10px] sm:text-xs uppercase tracking-[0.18em] text-ink-subtle">
            <span>Mindmaps</span>
            <span className="w-1 h-1 rounded-full bg-ink-subtle/50" />
            <span>Education</span>
            <span className="w-1 h-1 rounded-full bg-ink-subtle/50" />
            <span>Books</span>
          </div>
        </div>

        {/* Right-side editorial visual */}
        <div className="lg:col-span-5 relative animate-fade-in mt-2">
          <div className="relative bg-white rounded-2xl sm:rounded-3xl shadow-[0_30px_80px_-30px_rgba(30,77,58,0.35)] border border-ink/5 overflow-hidden">
            <div className="px-4 sm:px-5 py-3 border-b border-ink/5 flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
              <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
              <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
              <span className="mx-auto text-[10px] sm:text-[11px] text-ink-subtle truncate">journal.summarymaps.com</span>
            </div>
            <div className="p-5 sm:p-7 md:p-8">
              <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-ink-subtle mb-3">Featured · Mindmaps</div>
              <div className="font-serif text-xl sm:text-2xl leading-tight text-ink">How mind maps rewire the way you remember books.</div>
              <p className="mt-3 text-sm text-ink-muted leading-relaxed">
                Linear notes are a fight you lose by Friday. Branching notes are architecture.
              </p>
              <div className="mt-5 sm:mt-6 flex items-center justify-center">
                <div className="px-4 py-2 rounded-xl bg-brand text-white text-sm font-medium shadow">Atomic Habits</div>
              </div>
              <div className="mt-4 sm:mt-5 grid grid-cols-2 gap-2.5 sm:gap-3">
                <div className="rounded-lg sm:rounded-xl bg-cat-mindmaps/70 border border-cat-mindmaps text-cat-mindmaps-text text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-2 text-center">The 4 Laws</div>
                <div className="rounded-lg sm:rounded-xl bg-cat-education/70 border border-cat-education text-cat-education-text text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-2 text-center">Identity Change</div>
                <div className="rounded-lg sm:rounded-xl bg-cat-books/70 border border-cat-books text-cat-books-text text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-2 text-center">1% Better Daily</div>
                <div className="rounded-lg sm:rounded-xl bg-cat-new-releases/70 border border-cat-new-releases text-cat-new-releases-text text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-2 text-center">Environment</div>
              </div>
            </div>
          </div>

          <div className="hidden md:flex absolute -left-6 top-16 items-center gap-2 bg-white border border-ink/5 rounded-xl px-3 py-2 shadow-sm">
            <Sparkles className="w-3.5 h-3.5 text-brand" />
            <span className="text-xs text-ink-muted">New essay · 4 min read</span>
          </div>
        </div>
      </div>
    </section>
  );
}
